import { useAuth } from '@cash-web/shared-auth-data-access-context'

import { DevelopmentBanner } from './DevelopmentBanner'
import { LoadingPage } from './LoadingPage'
import { useLogout } from './logout'

type AuthRequiredProps = {
  children: React.ReactElement
  loadingElement?: React.ReactElement | null
}

export const AuthRequired = ({ children, loadingElement = <LoadingPage /> }: AuthRequiredProps) => {
  const { profile, isLoading, error } = useAuth()
  const logout = useLogout()

  if (isLoading) {
    return loadingElement
  }

  if (error != null) {
    if (error.response?.status === 401) {
      if (process.env['NODE_ENV'] === 'development') {
        return <DevelopmentBanner>{children}</DevelopmentBanner>
      } else {
        logout({ returnToSameUrl: true })
        return null
      }
    }
  }

  if (profile != null) {
    return children as React.ReactElement
  }

  throw error
}
